var Tour = {
			table: $("#tourResultTable"),
			resultTable:$("#tourResultTable .item"),
			hasResult:null,
			searchByTour:null,
			numAdult:null,
			numChild:0,
			numInfant:0,
			source:null
					};
var TourSearch = {
  searchAutoCompleteId:null,
  searchUrl:null,
  dateRange:null,
}

$(document).ready(function(){
	
	if(Tour.numAdult){
		$('#paxADT').val(Tour.numAdult);
		$('#paxCHD').val(Tour.numChild);
		$('#paxINF').val(Tour.numInfant);
		
		$(".spinnerTravelerADT").change();
		$(".spinnerTravelerCHD").change();
		$(".spinnerTravelerINF").change();
	} else if($.cookie('numAdultFlight')){ //TODO: neden flighta bakılmış bilmiyorum, refactor ederken bu mantığa dokunmadım.
		$('#paxADT').val($.cookie('numAdultFlight'));
		$('#paxCHD').val($.cookie('numChildFlight'));
		$('#paxINF').val($.cookie('numInfantFlight'));
		
		$(".spinnerTravelerADT").change();
		$(".spinnerTravelerCHD").change();
		$(".spinnerTravelerINF").change(); 
	} else {
		$('#paxADT').val("1");
		$('#paxCHD').val("0");
		$('#paxINF').val("0");
	}
	
	if(Tour.source){
		var date = new Date();
		date.setTime(date.getTime() + (30 * 60 * 1000)); //30 minutes
		$.cookie('source', '${source}', { expires : date,  path : '/' });
	}
	
	tourSearch.init(Tour.hasResult, Tour.searchByTour);
	tourSearchFilter.init();
	
    $( ".warningDialog" ).dialog({
        resizable: false,
        height:240,
        width:400,
        modal: true,
        buttons:
            [
                {
                    text: FmtMessage.getMessage('js.search.no.result'),
                    click: function() {
                        $( this ).dialog( "close" );
                    }
                }
            ]
    });
    
    
    $(".clear_input").click(function () {
		$("[name=tourId]").val("");
		$("[name=searchByTour]").val(false);
		$("[name=isSearch]").val(false);
		clearCookieSearchValues();
	})
	
    var $tourTypesList = $("#tour-types");
        
        $tourTypesList.find('li').sort(function(a, b) {

            var textA = a.lastElementChild.innerText.toLowerCase();
            var textB = b.lastElementChild.innerText.toLowerCase();

            if (textA < textB) 
               return -1; 
            if (textA > textB)
               return 1;
            return 0; 
        }).appendTo("#tour-types");
				
});

function showTourType(tourTypeId){
	$('#tourType').val(tourTypeId);
	tourSearch.searchByTour(null, tourTypeId);
}
function showTourRecomended(tourid){
	$("input[type='hidden'][name='tourId']").val(tourid);
	tourSearch.searchByTour(tourid, null);
}			

var tourSearch = function() {
	
	var winstatus = 'scrollbars=no,menubar=no,height=700,width=800,resizable=yes,toolbar=no,location=no,status=no';
	var detailwin=null;

	this.init = function (hasResult, searchByTour){
		
		$('[name="tourSearchForm"]').validate();

		var $toDate = $("[name=checkOutDate]");
		var $fromDate = $("[name=checkInDate]");
		parseCookieSearchValues();

		var re = null;
		$.widget("custom.catcomplete", $.ui.autocomplete, {
			_renderMenu : function(ul, items) {
				var that = this, currentCategory = "";
				$.each(items, function(index, item) {

					if (item.tourType != currentCategory) {

						if (item.tourType == 7) {
							ul.append("<li class='ui-autocomplete-category ui-state-disabled' >"+ FmtMessage.getMessage('js.tour.autocomplete.result.tour') +"</li>");
						} else if (item.tourType == 5) {
							ul.append("<li class='ui-autocomplete-category ui-state-disabled' >" +  FmtMessage.getMessage('js.result.category') + "</li>");
						}  
						else if (item.tourType == 3) {
							ul.append("<li class='ui-autocomplete-category ui-state-disabled' >" +  FmtMessage.getMessage('js.result.city') + "</li>");
						}
						else if (item.tourType == 1) {
							ul.append("<li class='ui-autocomplete-category ui-state-disabled' >" +  FmtMessage.getMessage('js.result.tour.type') + "</li>");
						} 

						currentCategory = item.tourType;
					}
					that._renderItemData(ul, item);
				});
			},
	        _renderItem: function (ul, item) {
	    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
	    		return $("<li class='ui-autocomplete-item'></li>")
	    			.data("ui-autocomplete-item", item)
	    			.append("<a>" + item.label + "</a>")
	    			.appendTo(ul);
	    		}
		});
		
		$("#tourName").catcomplete({
			delay  : 300,
			source : function(request, response) {
				$.ajax({
					url : "/tour/autocomplete",
					dataType : "json",
					data : {
						query: $.trim($('#tourName').val()),
					},
					success : function(data) {
						if(data){
							
							re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
							
							response($.map(data,
								function(item) {
								
									if(item.cityName !== undefined && item.countryName !== undefined){
										return {
											value :	item.name + ', ' + item.cityName + ', ' + item.countryName,
											id : item.id,
											tourType : item.type,
											tourSaleType : item.tourSaleType
										}
									}
									return {
										value :	item.name,
										id : item.id,
										tourType : item.type,
										tourSaleType : item.tourSaleType
									}
									
								})
							);
						}
					}
				});
			},
			minLength : 3,
			search: function (a, b) {
				$("#tourId").val('');
			},
			select: function (a, b) {
				document.activeElement.blur();
				$("input[type='hidden'][name='tourId']").val(b.item.id);
			}
		});

		$('#tourCountry').on('change',function(){
			$.ajax({
				url : "/getCities",
				dataType : "json",
				data : {
					country: $("#tourCountry").val()
				},
				success: function(data) {
					


					var options = '<option value="0">' + FmtMessage.getMessage('js.tours.searchForm.city.select') + '</option>';
					if(data.cities != null){
						$.each(data.cities,function(idx,c){
							options += '<option value="' + c.cityId
									+  '">'+ c.city + '</option>';
						});

					}
					$('#tourCity').html(options);
				}
			});
		}).trigger("change");
		
		$("#tourDateRange").change(function() {
			if(this.selectedIndex > -1){
				var selectedValues = this.options[this.selectedIndex].value.split("-");
				var month = selectedValues[0];
				var year = (parseInt(selectedValues[1])+parseInt("1900")).toString();
				var yearControl = selectedValues[1];
				var selectedText = this.options[this.selectedIndex].text;
				$(this).parent().find('.field-value-select').text(selectedText);
				if(selectedValues != ""){
					$('[name=selDateMonth]').val(month);
					$('[name=selDateYear]').val(year);
				}else{
					$('[name=selDateMonth]').val("");
					$('[name=selDateYear]').val("");
				}
			} else {
				$('[name=selDateMonth]').val("");
				$('[name=selDateYear]').val("");
			}
		}).change();	

	}
	
	this.searchByTour = function (tourId, typeId){
		
		//tourId == null && typeId == null means tour search is proceed via autocomplete !!
		var fromAutocomplete = (tourId == null && typeId ==null) ? true : false;
		var tourIdSelected = $("input[type='hidden'][name='tourId']").val();
		if(fromAutocomplete){
			$('[name="tourSearchForm"]').removeAttr("target");
		}
		$("form[name='tourSearchForm']")
        $("input[name='isSearch']").val(true);
		
		//tour selected directly from main page
        if(tourId !== undefined && tourId != null){
	        	$("input[name='tourId']").val(tourId);
	    		$("input[name='tourType']").val("");
	    		$("input[name='searchByTour']").val(true);

        }
        //Tour type selected from main page
        else if(typeId !== undefined && typeId != null){	      
	    		$("input[name='tourType']").val(typeId);
        }
        
        //tour search proceed via search box
        else{
        		checkSearchBoxText(tourIdSelected);
        		$("input[name='tourType']").val("");
        		$("input[name='searchByTour']").val(true);
        	    
        }
		var $form = $('[name="tourSearchForm"]');
		var formValid = $form.valid();
		if(formValid){
			if(fromAutocomplete){
				putCookieSearchValues(); 
			}
//			openLoaderBox();
			$form.submit();
		}
	}
	this.putCookieSearchValues =function(){
		var date = new Date();
		date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour
		TourSearch.searchAutoCompleteId =$("input[type='hidden'][name='tourId']").val();
		TourSearch.searchUrl = $('[name="tourName"]').val();
		TourSearch.dateRange= $("#tourDateRange").val();
		$.cookie('tourSearchValues',  JSON.stringify(TourSearch), { expires : date,  path : '/' });
	}

	this.clearCookieSearchValues = function () {
		$.cookie('tourSearchValues', null, {path:'/'})
	}

	this.parseCookieSearchValues= function(){
		var TourSearch = JSON.parse($.cookie("tourSearchValues"));
		if(TourSearch) {
		$('[name="tourName"]').val(TourSearch.searchUrl);
		$("input[type='hidden'][name='tourId']").val(TourSearch.searchAutoCompleteId);
		$("#tourDateRange").val(TourSearch.dateRange);
		}
	}
	this.showTourDetail = function (tourUUID, currency){	   

		if(tourUUID != null){	
			var url = URL_MAPPING.resolveUrl('/tours/detail');
			url = url+'?tour=' + tourUUID;
			var win = window.open(url, '_blank');
			 win.focus();
			
			
		}
		
	}
	
	this.showOtherPrice = function (tourId){
		$("input[type='hidden'][name='tourId']").val(tourId);
		$(".cover_" + tourId).fadeToggle('fast');
	}
	
	this.getPriceDetail = function (tourId){

		var $form = $('[name="priceDetailToursForm"]');
		var formValid = $form.valid();
		if(formValid){
			openLoaderBox();
			$form.submit();
		}
		
	}
	
	return {
		init : init,
		searchByTour : searchByTour,
		showTourDetail : showTourDetail,
		showOtherPrice : showOtherPrice,
		getPriceDetail : getPriceDetail
	}

}();

function checkSearchBoxText(tourIdSelected){
	if($("#tourName").val() != ""){
		$("input[name='tourId']").val(tourIdSelected);

	}
	else{
		$("input[name='tourId']").val("");
	}
}